
export const handleDocumentDownload = (fileUrl) => {
    try {
        const urlParts = fileUrl.split("/");
        const originalName = urlParts[urlParts.length - 1];

        const link = document.createElement("a");
        link.href = fileUrl;
        link.download = originalName;
        link.target = "_blank";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    } catch (err) {
        console.error("Download failed:", err);
    }
};

export const truncateWords = (text = "", limit = 10) => {
  if (typeof text !== "string") return "";

  const words = text.trim().split(/\s+/);

  if (words.length <= limit) return text;

  return words.slice(0, limit).join(" ") + "...";
};

export const fixEncoding = (str = "") => {
  if (typeof str !== "string") return "";

  const text = truncateWords(str, 10);

  return text
    .replace(/Ã«/g, "ë")
    .replace(/Ã§/g, "ç")
    .replace(/Ã/g, "Ç")
    .replace(/Ã/g, "Ë");
};

export function formatDateDMY(dateString) {
  const date = new Date(dateString);

  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();

  return `${day}-${month}-${year}`;
}

export const formatToDateInput = (value) => {
      if (!value) return "";

      const date = new Date(value);
      if (Number.isNaN(date.getTime())) return "";

      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");

      return `${year}-${month}-${day}`;
};

export const isAtLeastYears = (date, years) => {
  if (!date) return false;

  const inputDate = new Date(date);
  if (isNaN(inputDate)) return false;

  const today = new Date();

  let diff = today.getFullYear() - inputDate.getFullYear();
  const m = today.getMonth() - inputDate.getMonth();

  if (m < 0 || (m === 0 && today.getDate() < inputDate.getDate())) {
    diff--;
  }

  return diff >= years;
};